import { styled } from '@mui/material/styles';
import { Container, Typography, Link } from '@mui/material';
import SectionTitle from '../../../components/SectionTitle';
import CareersForm from '../../../components/forms/CareersForm';
import BrokerConsultantNelspruitFile from '../../../assets/documents/about-us/Broker-Consultant-Nelspruit-2026.pdf';

const CareersRoot = styled('div')(({ theme }) => ({
    padding: '50px 0',
}));

const CareersDesc = styled(Typography)(({ theme }) => ({
    fontStyle: 'italic',
}));

const CareerList = styled('ul')(({ theme }) => ({
    margin: 0,
    paddingLeft: theme.spacing(3),
    marginBottom: theme.spacing(3),
}));

const CareerPoint = styled('li')(({ theme }) => ({
    marginBottom: theme.spacing(1),
}));

const Careers = () => {
    return (
        <CareersRoot>
            <Container maxWidth="lg">
                <SectionTitle
                    title="Join Our Team"
                    subtitle="Current positions available"
                    align="left"
                />
                {/* <CareerList>
                    <CareerPoint>
                        <Link 
                            href={SeniorUnderwriterFile} 
                            target="_blank" 
                            rel="noopener"
                            underline="hover"
                        >
                            Senior Underwriter
                        </Link>
                    </CareerPoint>
                </CareerList> */}
                <CareerList>
                    <CareerPoint>
                        <Link 
                            href={BrokerConsultantNelspruitFile} 
                            target="_blank" 
                            rel="noopener noreferrer"
                            underline="hover"
                        >
                            Broker Consultant Nelspruit
                        </Link>
                    </CareerPoint>
                </CareerList>
                <CareersDesc variant="body1">
                    Feel free to submit your details for future positions
                </CareersDesc>
                <CareersForm />
            </Container>
        </CareersRoot>
    );
};

export default Careers;
